import { forwardRef, type Ref, type SVGProps } from "react";
const IconShareWebOutlineSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path
      fill="currentColor"
      d="m15 5.41-4.29 4.3a1.004 1.004 0 0 1-1.42-1.42l6-6a1 1 0 0 1 .33-.21 1 1 0 0 1 .76 0 1 1 0 0 1 .33.21l6 6a1 1 0 0 1 0 1.42 1 1 0 0 1-1.42 0L17 5.41V23a1 1 0 1 1-2 0z"
    />
    <path
      fill="currentColor"
      d="M23 14h6a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V15a1 1 0 0 1 1-1h6a1 1 0 1 1 0 2H4v12h24V16h-5a1 1 0 1 1 0-2"
    />
  </svg>
);
const ForwardRef = forwardRef(IconShareWebOutlineSVG);
ForwardRef.displayName = "IconShareWebOutline";
export { ForwardRef as IconShareWebOutline };
